import { useLazyQuery } from '@apollo/react-hooks'
import theme from '@ifca-root/react-component/src/assets/theme'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  StyledMenu,
  StyledMenuItem,
} from '@ifca-root/react-component/src/components/others/Menu'
import {
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  useMediaQuery,
} from '@material-ui/core'
import { KeyboardArrowRight } from '@material-ui/icons'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { GET_PACKAGE_BY_ACCOUNT } from 'containers/AccountModule/GraphQL/AccountQuery'
import { dropdownOption } from 'containers/DigitalReportModule/function/DigitalReportDropdown'
import { AcctPermission } from 'generated/graphql'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import { SubscriptionClient } from 'SubscriptionClient'

export const GLDigitalReportSubmenu = (props: any) => {
  let history = useHistory()
  const [labelState, setLabelState] = useState<string>('General Ledger Reports')
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const { handlePermHidden } = usePermissionChecker()
  const { anchorEl, handleClick, handleClose } = useMenuOption()
  const location = useLocation()
  const isHomeDefault = localStorage.getItem('isDefault')
  const CompanyID = localStorage.getItem('latestCompany')
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })
  const { mode } = props
  // ACCOUNTX API CALLS
  const [
    loadPackage,
    {
      loading: packageLoading,
      data: { getPackageByAccount } = { getPackageByAccount: [] },
    },
  ] = useLazyQuery(GET_PACKAGE_BY_ACCOUNT, {
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    client: SubscriptionClient,
  })

  // LocalStorage for lastAccessedModule
  localStorage.setItem('lastAccessedModule', 'DIGITAL_REPORTS')

  const submenuList = [
    {
      path: `/digital-reports/general-ledger/gl-journal-entity-report/parameters`,
      title: `GL Journal By Account`,
      permission: AcctPermission.GeneralLedgerDigitalReportsGlJournalView,
    },
    {
      path: `/digital-reports/general-ledger/gl-journal-costcentre-report/parameters`,
      title: `GL Journal Detail Listing By Department`,
      permission:
        AcctPermission.GeneralLedgerDigitalReportsGlJournalCostCentreView,
    },
    {
      path: `/digital-reports/general-ledger/trial-balance-entity-report/parameters`,
      title: `Trial Balance by Entity`,
      permission: AcctPermission.GeneralLedgerDigitalReportsTrialBalanceView,
    },
    {
      path: `/digital-reports/general-ledger/trial-balance-costcentre-report/parameters`,
      title: `Trial Balance by Department`,
      permission:
        AcctPermission.GeneralLedgerDigitalReportsTrialBalanceCostCentreView,
    },
    {
      path: `/digital-reports/general-ledger/mastercoa-listing-report/parameters`,
      title: `Master COA Listing`,
      deployed: process.env.REACT_APP_LOCAL_DB === 'local' ? true : false,
    },
    {
      path: `/digital-reports/general-ledger/entitycoa-department-listing-report/parameters`,
      title: `Entity COA by Department Listing`,
    },
    {
      path: `/digital-reports/general-ledger/general-ledger-status-report/parameters`,
      title: `GL Listing with status`,
      // deployed: true,
      permission:
        AcctPermission.GeneralLedgerDigitalReportsListingWithStatusView,
    },
    // {
    //   path: `/digital-reports/general-ledger/gl-journal-listing-by-account-with-balances/parameters`,
    //   title: `GL Journal Listing by Account With Balances`,
    //   deployed: true,
    // },
    // {
    //   path: `/digital-reports/general-ledger/gl-journal-listing-by-department-with-balances/parameters`,
    //   title: `GL Journal Listing By Department With Balances`,
    //   deployed: true,
    // },
    {
      path: `/digital-reports/general-ledger/ytd-ledger-report-by-account/parameters`,
      title: `YTD Ledger By Account Report`,
      deployed: true,
    },
    {
      path: `/digital-reports/general-ledger/statement-income-entity/parameters`,
      title: `Statement Of Comprehensive Income By Entity Report`,
      deployed: true,
    },
    {
      path: `/digital-reports/general-ledger/statement-income-department/parameters`,
      title: `Statement Of Comprehensive Income By Department Report`,
      deployed: true,
    },
  ]

  const backPath = () => {
    if (isHomeDefault === 'true') return history.push(`/`)
    else {
      history.push({
        pathname:
          mode === 'general-ledger'
            ? `/general-ledger/${CompanyID}`
            : mode === 'cash-book'
            ? `/cash-book/${CompanyID}`
            : mode === 'account-receivable'
            ? `/account-receivable/${CompanyID}`
            : mode === 'general-purchase'
            ? `/general-purchase/${CompanyID}`
            : mode === 'inventory-control'
            ? `/inventory-control/${CompanyID}`
            : mode === 'fixed-assets'
            ? `/fixed-assets/${CompanyID}`
            : `/account-payable/${CompanyID}`,
      })
    }
  }

  const handleChange = value => {
    history.push({ pathname: value })
  }

  let package_permission
  if (!packageLoading) {
    package_permission = dropdownOption.filter(
      (v, i) =>
        getPackageByAccount?.includes(v?.package_name) ||
        v?.package_name === 'ACCESS_SECURITY'
    )
  }

  useEffect(() => {
    if (user?.accountID) {
      loadPackage({
        variables: { softwareCode: 'ACCOUNT', accountID: user?.accountID },
      })
    }
  }, [user?.accountID])

  return (
    <>
      {packageLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={backPath}
        smTitle={'General Ledger'}
        title={user?.companyName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Digital Reports', current: true },
        ]}
      />
      <DynamicSubHeader
        title={labelState}
        handleClick={e => {
          handleClick(e)
        }}
        dropDownOptions={
          <StyledMenu
            id="customized-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {package_permission?.map(x => {
              if (handlePermHidden({ permEnum: x?.permission }))
                return (
                  <StyledMenuItem
                    onClick={e => {
                      setLabelState(x?.label)
                      handleChange(x?.path)
                      handleClose()
                    }}
                    selected={location.pathname.includes(x.path)}
                  >
                    <ListItemText primary={x.label} />
                  </StyledMenuItem>
                )
            })}
          </StyledMenu>
        }
      />
      <ContentWrapper
        float
        style={{
          marginTop: isDesktop ? '100px' : '40px',
          top: isDesktop ? '47px' : null,
        }}
      >
        <List className="core-list">
          {submenuList.map((el, index) => {
            if (
              handlePermHidden({
                permEnum: el?.permission,
              })
            )
              return (
                <ListItem key={index} onClick={() => history.push(el?.path)}>
                  <ListItemText
                    style={{ textAlign: 'right', marginLeft: '5px' }}
                    primary={<span className="xsTitle">{el?.title}</span>}
                  />
                  <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="delete">
                      <KeyboardArrowRight
                        onClick={() => history.push({ pathname: el.path })}
                      />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              )
          })}
        </List>
      </ContentWrapper>
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
      {/* FOOTER */}
    </>
  )
}
